<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-hub-primary">
    <router-link :to="{ name: 'Home'}" class="navbar-brand"><img src="../../assets/images/header_image.png" height="100" width="168"></router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" v-if="is_authenticated">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent" v-if="is_authenticated && ($route.path !== '/' || scoped_site_id === 1)">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'CalendarScheduler' }" class="nav-link">
            <img src="../../assets/images/nav_icons/scheduler.png" height="25" width="25">
            Scheduler
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <a class="nav-link dropdown-toggle" href="" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
            <img src="../../assets/images/nav_icons/zone_manager.png" height="25" width="25">
            Zones
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <router-link :to="{ name: 'ZoneManager' }" class="dropdown-item">Manager</router-link>
            <router-link :to="{ name: 'ZoneMap'}" class="dropdown-item">Map</router-link>
          </div>
        </li>
        <li class="nav-item" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'Devices' }" class="nav-link">
            <img src="../../assets/images/nav_icons/devices.png" height="25" width="25">
            Devices
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <a class="nav-link dropdown-toggle" href="" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
            <img src="../../assets/images/nav_icons/sounds.png" height="25" width="25">
            Sounds
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <router-link :to="{ name: 'SoundFilesIndex' }" class="dropdown-item">Files</router-link>
            <router-link :to="{ name: 'PlaylistsIndex' }" class="dropdown-item">Playlists</router-link>
          </div>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'Notifications' }" class="nav-link">
            <img src="../../assets/images/nav_icons/announcements.png" height="25" width="25">
            Announcements
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'AlertIndex' }" class="nav-link">
            <i class="fas fa-exclamation-triangle" style="font-size:20px;"></i>
            Alerts
          </router-link>
        </li>
        <li class="nav-item dropdown" v-if="[2,3,4].includes(logged_in_user.group_id)">
          <router-link :to="{ name: 'AdminDashboard' }" class="nav-link">
            <img src="../../assets/images/nav_icons/admin.png" height="25" width="25">
            Admin
          </router-link>
        </li>
        <li class="nav-item" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
          <a class="nav-link" href="http://help.g2com.online/">
            <img src="../../assets/images/nav_icons/training.png" height="25" width="25">
            Help & Training
          </a>
        </li>
      </ul>
      <div>
        <img :src="'./upload/images/site_logos/' + scoped_site_id + '.png'" :alt="'logo ' + scoped_site_id" width="100" height="100"><img>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      is_authenticated: 'isAuthenticated',
      scoped_site_id: 'scopedSiteId',
      logged_in_user: 'loggedInUser'
    })
  }
}
</script>
